import React, { createContext, useContext, useRef } from "react";
import EventBus from "js-event-bus";

const EventBusContext = createContext(null);
export const useEventBus = () => useContext(EventBusContext);

export const EventBusProvider = ({ eventBus, children }) => {
  const fallbackEventBus = useRef(new EventBus()).current;

  return (
    <EventBusContext.Provider value={eventBus || fallbackEventBus}>
      {children}
    </EventBusContext.Provider>
  );
};

export const EVENT_BUS_EVENTS = {
  ITEM_VIEWS_POSTED: "ITEM_VIEWS_POSTED",
};

export { EventBus };
